import { Goal, ID, Task, UpdateGoal } from '@griply/types';

// `sections` is an absolute replacement; `taskCount` is a signed delta applied
// via `increment` by the update-goal mutation, so it counts only the deleted
// tasks owned by this goal (sub-goal tasks live under their own goal's count).
export const buildSectionDeleteUpdate = (
  goal: Goal,
  sectionId: ID,
  tasks?: Task[],
): UpdateGoal => ({
  id: goal.id,
  sections: goal.sections?.filter(({ id }) => id !== sectionId) ?? null,
  taskCount: tasks?.length
    ? tasks.filter(({ goalId }) => goalId === goal.id).length * -1
    : 0,
});
